// ============================================================================
// countries.js — SHTETET, të pavarura nga gjuha.
//
// PROBLEMI I VJETËR: shteti ruhej si TEKST ("Kosovë"), prandaj (a) dilte shqip
// në çdo gjuhë, (b) harta e njihte vetëm nëse ishte shkruar saktë shqip, dhe
// (c) admini duhej t'i shtonte një nga një me dorë.
//
// ZGJIDHJA: ruajmë KODIN ISO 3166-1 alfa-2 ("XK", "DE") dhe emrin e shfaqim me
// `Intl.DisplayNames`, të cilin e ka vetë shfletuesi — pra emri vjen automatikisht
// në gjuhën e përdoruesit, pa asnjë skedar përkthimi dhe pa varësi të re.
//
// PËRPUTHSHMËRIA MBRAPA: të dhënat ekzistuese kanë emra si tekst. `resolveCountry`
// e njeh edhe kodin edhe emrin (në çfarëdo gjuhe), kështu asgjë nuk humbet.
//
// Shënim: "XK" (Kosova) s'është ende kod zyrtar ISO, prandaj disa shfletues
// s'kanë emër për të — e trajtojmë veçmas më poshtë.
// ============================================================================

// Të gjitha kodet ISO 3166-1 alfa-2 (+ XK për Kosovën).
export const COUNTRY_CODES = [
  "XK","AL","AD","AE","AF","AG","AI","AM","AO","AQ","AR","AS","AT","AU","AW","AX","AZ",
  "BA","BB","BD","BE","BF","BG","BH","BI","BJ","BL","BM","BN","BO","BQ","BR","BS","BT",
  "BV","BW","BY","BZ","CA","CC","CD","CF","CG","CH","CI","CK","CL","CM","CN","CO","CR",
  "CU","CV","CW","CX","CY","CZ","DE","DJ","DK","DM","DO","DZ","EC","EE","EG","EH","ER",
  "ES","ET","FI","FJ","FK","FM","FO","FR","GA","GB","GD","GE","GF","GG","GH","GI","GL",
  "GM","GN","GP","GQ","GR","GS","GT","GU","GW","GY","HK","HM","HN","HR","HT","HU","ID",
  "IE","IL","IM","IN","IO","IQ","IR","IS","IT","JE","JM","JO","JP","KE","KG","KH","KI",
  "KM","KN","KP","KR","KW","KY","KZ","LA","LB","LC","LI","LK","LR","LS","LT","LU","LV",
  "LY","MA","MC","MD","ME","MF","MG","MH","MK","ML","MM","MN","MO","MP","MQ","MR","MS",
  "MT","MU","MV","MW","MX","MY","MZ","NA","NC","NE","NF","NG","NI","NL","NO","NP","NR",
  "NU","NZ","OM","PA","PE","PF","PG","PH","PK","PL","PM","PN","PR","PS","PT","PW","PY",
  "QA","RE","RO","RS","RU","RW","SA","SB","SC","SD","SE","SG","SH","SI","SJ","SK","SL",
  "SM","SN","SO","SR","SS","ST","SV","SX","SY","SZ","TC","TD","TF","TG","TH","TJ","TK",
  "TL","TM","TN","TO","TR","TT","TV","TW","TZ","UA","UG","UM","US","UY","UZ","VA","VC",
  "VE","VG","VI","VN","VU","WF","WS","YE","YT","ZA","ZM","ZW",
];

// Emrat e Kosovës — shumica e shfletuesve s'e njohin "XK".
const XK_NAMES = {
  sq: "Kosovë", en: "Kosovo", de: "Kosovo", fr: "Kosovo", it: "Kosovo",
  sv: "Kosovo", no: "Kosovo", nb: "Kosovo", nn: "Kosovo", es: "Kosovo",
  tr: "Kosova", nl: "Kosovo", da: "Kosovo", fi: "Kosovo",
};

// EMRAT SHQIP TË SHTETEVE — 6 shtator 2026. `Intl.DisplayNames("sq")` në
// shumë pajisje (Android WebView, Chrome pa të dhëna CLDR për shqipen) bie te
// anglishtja: dilte «nga Kosovë për në Germany». Kjo tabelë fiton gjithmonë
// kur gjuha është shqip; ç'nuk është këtu, e merr Intl si më parë.
const SQ_NAMES = {
  AL: "Shqipëri", XK: "Kosovë", MK: "Maqedoni e Veriut", ME: "Mal i Zi", RS: "Serbi", BA: "Bosnjë e Hercegovinë",
  HR: "Kroaci", SI: "Slloveni", GR: "Greqi", BG: "Bullgari", RO: "Rumani", TR: "Turqi",
  DE: "Gjermani", AT: "Austri", CH: "Zvicër", IT: "Itali", FR: "Francë", BE: "Belgjikë", NL: "Holandë", LU: "Luksemburg",
  GB: "Britani e Madhe", IE: "Irlandë", ES: "Spanjë", PT: "Portugali",
  SE: "Suedi", NO: "Norvegji", DK: "Danimarkë", FI: "Finlandë", IS: "Islandë",
  PL: "Poloni", CZ: "Çeki", SK: "Sllovaki", HU: "Hungari", UA: "Ukrainë", RU: "Rusi", BY: "Bjellorusi",
  LT: "Lituani", LV: "Letoni", EE: "Estoni", MD: "Moldavi", CY: "Qipro", MT: "Maltë",
  US: "Shtetet e Bashkuara", CA: "Kanada", AU: "Australi", NZ: "Zelandë e Re",
  AE: "Emiratet e Bashkuara Arabe", SA: "Arabi Saudite", QA: "Katar", EG: "Egjipt", IL: "Izrael",
  JP: "Japoni", CN: "Kinë", IN: "Indi", BR: "Brazil", AR: "Argjentinë", MX: "Meksikë", ZA: "Afrikë e Jugut",
};

const cache = new Map(); // `${lang}` → Intl.DisplayNames

function displayNames(lang) {
  const key = lang || "en";
  if (cache.has(key)) return cache.get(key);
  let dn = null;
  try {
    dn = new Intl.DisplayNames([key, "en"], { type: "region" });
  } catch (e) { /* shfletues i vjetër → biem te kodi */ }
  cache.set(key, dn);
  return dn;
}

// Emri i shtetit në gjuhën e dhënë. Kthen vetë kodin nëse s'ka emër.
export function countryName(code, lang = "en") {
  if (!code) return "";
  const up = String(code).toUpperCase();
  if (up === "XK") return XK_NAMES[lang] || XK_NAMES[String(lang).split("-")[0]] || "Kosovo";
  if (String(lang).split("-")[0] === "sq" && SQ_NAMES[up]) return SQ_NAMES[up];
  const dn = displayNames(lang);
  if (!dn) return up;
  try { return dn.of(up) || up; } catch (e) { return up; }
}

// Shtetet që dalin GJITHMONË në krye — platforma është shqiptare, dhe pa këtë
// Kosova bie diku te pozicioni ~120 alfabetikisht.
export const PINNED_CODES = ["XK", "AL", "MK", "ME"];

// Lista e plotë, në tre shtresa:
//   1) `favorites` — shtetet që kjo familje i përdor VËRTET (të renditura sipas
//      shpeshtësisë). Kështu një familje e diasporës në Gjermani e gjen
//      Gjermaninë në krye pa e konfiguruar askush.
//   2) të ngjiturat e parazgjedhura (Kosovë/Shqipëri/…), për familjet e reja.
//   3) të tjerat, alfabetikisht SIPAS GJUHËS aktive.
export function countryOptions(lang = "en", favorites = []) {
  const fav = favorites.map((c) => resolveCountry(c)).filter((c) => c && COUNTRY_CODES.includes(c));
  const seen = new Set(fav);
  const pin = PINNED_CODES.filter((c) => !seen.has(c));
  pin.forEach((c) => seen.add(c));
  const rest = COUNTRY_CODES
    .filter((c) => !seen.has(c))
    .map((code) => ({ code, name: countryName(code, lang) }))
    .sort((a, b) => a.name.localeCompare(b.name, lang));
  return [
    ...fav.map((code) => ({ code, name: countryName(code, lang), favorite: true })),
    ...pin.map((code) => ({ code, name: countryName(code, lang), pinned: true })),
    ...rest,
  ];
}

// Shtetet e përdorura nga kjo familje, nga më i shpeshti te më i rralli.
// Merr listën e personave (ose çfarëdo objektesh me `birth_country`).
export function familyCountryCodes(people) {
  const counts = {};
  const list = Array.isArray(people) ? people : Object.values(people || {});
  for (const p of list) {
    const code = resolveCountry(p && p.birth_country);
    if (code) counts[code] = (counts[code] || 0) + 1;
  }
  return Object.entries(counts).sort((a, b) => b[1] - a[1]).map(([code]) => code);
}

// A duket si kod ISO? (dy shkronja të mëdha)
export const isCountryCode = (v) => typeof v === "string" && /^[A-Za-z]{2}$/.test(v.trim());

// --- Njohja e vlerave të vjetra (emra si tekst, në çfarëdo gjuhe) ----------
// Ndërton një hartë emër→kod për disa gjuhë njëherësh, që edhe të dhënat e
// shkruara shqip më parë të njihen. Llogaritet një herë dhe ruhet.
let reverseMap = null;
function buildReverse() {
  if (reverseMap) return reverseMap;
  const m = {};
  const langs = ["sq", "en", "de", "fr", "it", "sv", "no", "es", "tr", "nl"];
  for (const code of COUNTRY_CODES) {
    for (const l of langs) {
      const n = countryName(code, l);
      if (n) m[n.trim().toLowerCase()] = code;
    }
  }
  // Alias të zakonshëm që shkruhen ndryshe nga njerëzit.
  Object.assign(m, {
    "kosova": "XK", "kosovë": "XK", "kosove": "XK", "republika e kosovës": "XK",
    "shqiperi": "AL", "shqipëria": "AL", "shqiperia": "AL",
    "usa": "US", "u.s.a.": "US", "amerika": "US", "shtetet e bashkuara": "US",
    "uk": "GB", "angli": "GB", "anglia": "GB", "britania e madhe": "GB",
    "zvicer": "CH", "zvicra": "CH", "gjermani": "DE", "gjermania": "DE",
    "itali": "IT", "italia": "IT", "maqedoni": "MK", "maqedonia": "MK",
    "mali i zi": "ME", "serbi": "RS", "serbia": "RS", "turqi": "TR", "turqia": "TR",
    "greqi": "GR", "greqia": "GR", "suedi": "SE", "suedia": "SE",
    "norvegji": "NO", "norvegjia": "NO", "belgjike": "BE", "belgjika": "BE",
    "austri": "AT", "austria": "AT", "france": "FR", "franca": "FR",
  });
  reverseMap = m;
  return m;
}

// Nga çfarëdo vlere (kod OSE emër në çfarëdo gjuhe) → kodi ISO, ose null.
export function resolveCountry(value) {
  if (!value) return null;
  const v = String(value).trim();
  if (isCountryCode(v)) {
    const up = v.toUpperCase();
    if (COUNTRY_CODES.includes(up)) return up;
  }
  return buildReverse()[v.toLowerCase()] || null;
}

// Për SHFAQJE: nëse vlera është kod → përkthehet; ndryshe tregohet ashtu siç
// është ruajtur (të dhëna të vjetra ose shtete të shkruara me dorë).
export function displayCountry(value, lang = "en") {
  if (!value) return "";
  const code = resolveCountry(value);
  return code ? countryName(code, lang) : String(value);
}
